import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User switched ad account on the creative performance page',
  name: 'creative_performance_ad_account_switched',
};

export default META;
